export default "__VITE_ASSET__1ac0d794__"